import { render } from "./ClassPage.vue?vue&type=template&id=81fdbcac"
import script from "./ClassPage.vue?vue&type=script&lang=js"
export * from "./ClassPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wallace/Desktop/projects/virtap/virtap-webapp-support/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__